const RELOAD_KEY = 'chunk_reload_attempted';

export function isChunkLoadError(error) {
  return error?.name === 'ChunkLoadError'
    || error?.message?.includes('Loading chunk');
}

export function handleChunkLoadError(error) {
  if (!isChunkLoadError(error)) return false;

  const alreadyReloaded = sessionStorage.getItem(RELOAD_KEY);
  if (!alreadyReloaded) {
    sessionStorage.setItem(RELOAD_KEY, 'true');
    window.location.reload();
    return true;
  }

  // Already reloaded once and still failing - don't loop
  sessionStorage.removeItem(RELOAD_KEY);
  return false;
}

// Clear the flag on successful page loads (chunks loaded OK)
export function clearChunkReloadFlag() {
  sessionStorage.removeItem(RELOAD_KEY);
}
